import { Menu, MenuItem } from '@material-ui/core';
import React, { useState } from 'react';
import { NavbarButton } from '~frontend-common/components/base-navbar';
import { useHistory } from '~frontend-common/hooks/use-history';
import { useTranslator } from '~frontend-common/i18n/translator';
import { UserCircleIcon } from '~ui-kit/components/icons/user-circle-icon';
import { useAuthStore } from '~web-portal/stores';
import { Paths } from '~web-portal/variables/paths';

export function NavbarUserMenu() {
  const translator = useTranslator();
  const { tl } = translator;
  const history = useHistory();
  const clearAuth = useAuthStore.use.clearAuth();
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState<null | HTMLElement>(null);

  const handlePolicies = () => {
    history.push(Paths.policies);
    handleCloseUserMenu();
  };

  const handleProfile = () => {
    history.push(Paths.profile);
    handleCloseUserMenu();
  };

  const handleLogout = () => {
    clearAuth();
    history.push(Paths.login.path);
    handleCloseUserMenu();
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setUserMenuAnchorEl(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setUserMenuAnchorEl(null);
  };

  return (
    <>
      <NavbarButton icon={<UserCircleIcon />} onClick={handleOpenUserMenu} tooltip={tl('ui.navbar.tooltip.userMenu')} />

      <Menu
        id="navbar-user-menu"
        anchorEl={userMenuAnchorEl}
        keepMounted
        open={Boolean(userMenuAnchorEl)}
        onClose={handleCloseUserMenu}
      >
        <MenuItem onClick={handlePolicies}>{tl('ui.navbar.menu.policies')}</MenuItem>
        <MenuItem onClick={handleProfile}>{tl('ui.navbar.menu.profile')}</MenuItem>
        <MenuItem onClick={handleLogout}>{tl('ui.navbar.menu.logout')}</MenuItem>
      </Menu>
    </>
  );
}
